<template>

<div class="outer">

	<slot></slot>

</div>

</template>

<script>

export default {

	props: ['html']

}

</script>

<style scoped>

.outer {
	width: 100%;
}

</style>